import { Component, OnInit } from '@angular/core';
import {AchatService} from '../../../../../../services/achat/achat.service';

@Component({
  selector: 'app-annule-bn-recep',
  templateUrl: './annule-bn-recep.component.html',
  styleUrls: ['./annule-bn-recep.component.scss']
})
export class AnnuleBnRecepComponent implements OnInit {

    constructor(private dataService: AchatService) {}

    ngOnInit(): void {
        console.log('AnnuléCmdComponent initialized');
        this.dataService.filterBonReceptionByStatus('Annulé');

    }

}
